import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ISavedHomesState } from '@store';

export const selectSavedHomeState = createFeatureSelector<ISavedHomesState>('savedHomes');
export const selectSavedHomesList = createSelector(selectSavedHomeState, (state: ISavedHomesState) => state.list);
export const selectSavedHomesIds = createSelector(selectSavedHomeState, (state: ISavedHomesState) =>
  state.list.map((item) => item.id),
);
